import i18n from '@src/i18n';


const environmentUrl = {
  CLOUDUAT_URL: `https://appcube.ulanqab.huawei.com/cas/clientredirect?` +
    `service=https%3A%2F%2Fappcube.ulanqab.huawei.com%2Fbaas%2Fauth%2Fv1.0%` +
    `2Fsso%3Fredirect_url%3D%252Fstudio%252Findex.html&client_name=openwelink`,
  OPEN_URL: `http://appcube.cn-north-4.huaweicloud.com/cas/clientredirect?` +
    `service=https%3A%2F%2Fappcube.cn-north-4.huaweicloud.com%2Fbaas%2Fauth%2Fv1.0%2Fsso%3Fredirect_url` +
    `%3D%252Fstudio%252Findex.html%2523%252Fprojects%252F&client_name=openwelink`,
  NOT_PURCHASED: 'https://developer.huaweicloud.com/activity/weiguangjihua.html',
  GAMMA_ENVIRONMENT: location.origin,
};
const huaweicloud = {
  HUAWEI_CLOUD: `https://console.huaweicloud.com/welink/?region=cn-north-4#/welink/order/1`, // 生产环境华为云
  GAMMA_AND_UAT: `https://console.ulanqab.huawei.com/welink6/?region=cn-north-7#/welink/order/1`, // 测试环境华为云
};
const agreement = {
  QR_CODE: 'data:image/png;base64,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',
};

// 数值题和填空题的内容类型
const fillNumType = {
  FILL_TYPE: 'fillContentType',
  NUMBER_TYPE: 'numberType',
  FILL: 'fill',
  NUMBER: 'number',
};
const numberType = {
  // 数字题要输入的号码的类型
  OWNER: 'owner', // 自定义
  TEMPERATURE: 'temperature', // 体温
};
const fillType = {
  NORMAL_TEXT: 'normalText', // 不限制
  PHONE: 'phone', // 手机
  IDENTITY_ID: 'identityId', // 身份证
  QQ_number: 'QQnumber', // QQ号
  MAIL_BOX: 'mailbox', // 邮箱
  TELE_PHONE: 'telephone', // 电话（比如座机）
};
export default Object.assign({},// 所有的变量都在这里export导出 多个用逗号隔开
  environmentUrl,
  huaweicloud,
  agreement,
  fillNumType,
  numberType,
  fillType
);

/*
    表单来源
        iframe  外部集成
*/
export const SOURCE = {
  IFRAME: 'iframe'
}

export const QUESTION_TYPES = {
  /**
   * 填空题
   */
  FILL: 'fill',
  /**
   * 单选题
   */
  SINGLE_CHOICE: 'single-choice',
  /**
   * 多选题
   */
  MULTIPLE_CHOICE: 'multiple-choice',
  /**
   * 地区
   */
  AREA: 'area',
  /**
   * 位置
   */
  LOCATION: 'location',
  /**
   * 说明文字
   */
  DESCRIPTION: 'description',
  /**
   * 数字
   */
  NUMBER: 'number',
  /**
   * 日期
   */
  DATE: 'date',
  /**
   * 选择人员
   */
  PERSON: 'person',
  /**
   * 选择部门
   */
  DEPARTMENT: 'department',
  /**
   * 表格单选题
   */
  MATRIX_SINGLE_CHOICE: 'matrix-single-choice',
  /**
   * 表格填充题
   */
  MATRIX_FILL: 'matrix-fill',
  /**
   * 图片
   */
  PICTURE: 'picture',
  /**
   * 手写签名
   */
  SIGNATURE: 'signature',
  /**
   * 评分
   */
  SCORE: 'score',
  /**
   * 附件
   */
  ATTACHMENT: 'attachment',
  /**
   * 行程码
   */
  TRIP_CODE: 'trip-code',
  /**
   * 行程码2.0
   */
   ORCIDENTIFY:'ocrIdentify-tripcode',
  /* 健康码 */
  OCRIDENTIFYHEALTHCODE:'ocrIdentify-healthcode',
  /**
   * 核酸记录
   */
  OCR_NUCLEICACID_CODE: 'ocrIdentify-nucleicacidcode',
  /**
   * 分页题
   * 不进行实际的渲染
   */
  PAGINATION:'pagination'
};

export const numberChineseChange = {
  1: i18n.t('weform:num1'),
  2: i18n.t('weform:num2'),
  3: i18n.t('weform:num3'),
  4: i18n.t('weform:num4'),
  5: i18n.t('weform:num5'),
  6: i18n.t('weform:num6'),
  7: i18n.t('weform:num7'),
  8: i18n.t('weform:num8'),
  9: i18n.t('weform:num9'),
  10: i18n.t('weform:num10'),
  11: i18n.t('weform:num11'),
  12: i18n.t('weform:num12'),
  13: i18n.t('weform:num13'),
  14: i18n.t('weform:num14'),
  15: i18n.t('weform:num15'),
  16: i18n.t('weform:num16'),
  17: i18n.t('weform:num17'),
  18: i18n.t('weform:num18'),
  19: i18n.t('weform:num19'),
  20: i18n.t('weform:num20'),
  21: i18n.t('weform:num21'),
  22: i18n.t('weform:num22'),
  23: i18n.t('weform:num23'),
  24: i18n.t('weform:num24'),
  25: i18n.t('weform:num25'),
  26: i18n.t('weform:num26'),
  27: i18n.t('weform:num27'),
  28: i18n.t('weform:num28'),
  29: i18n.t('weform:num29'),
  30: i18n.t('weform:num30'),
  31: i18n.t('weform:num31'),
  32: i18n.t('weform:num32'),
  33: i18n.t('weform:num33'),
  34: i18n.t('weform:num34'),
  35: i18n.t('weform:num35'),
  36: i18n.t('weform:num36'),
  37: i18n.t('weform:num37'),
  38: i18n.t('weform:num38'),
  39: i18n.t('weform:num39'),
  40: i18n.t('weform:num40'),
  41: i18n.t('weform:num41'),
  42: i18n.t('weform:num42'),
  43: i18n.t('weform:num43'),
  44: i18n.t('weform:num44'),
  45: i18n.t('weform:num45'),
  46: i18n.t('weform:num46'),
  47: i18n.t('weform:num47'),
  48: i18n.t('weform:num48'),
  49: i18n.t('weform:num49'),
  50: i18n.t('weform:num50')
};

export const DEFAULT_QUESTION_TITLE = {
  [QUESTION_TYPES.SINGLE_CHOICE]: i18n.t('weform:singleChoice'),
  [QUESTION_TYPES.MULTIPLE_CHOICE]: i18n.t('weform:multipleChoice'),
  [QUESTION_TYPES.FILL]: i18n.t('weform:fill'),
  [QUESTION_TYPES.AREA]: i18n.t('weform:area'),
  [QUESTION_TYPES.DESCRIPTION]: i18n.t('weform:text'),
  [QUESTION_TYPES.LOCATION]: i18n.t('weform:location'),
  [QUESTION_TYPES.NUMBER]: i18n.t('weform:number'),
  [QUESTION_TYPES.DATE]: i18n.t('weform:date'),
  [QUESTION_TYPES.PERSON]: i18n.t('weform:personSelet'),
  [QUESTION_TYPES.DEPARTMENT]: i18n.t('weform:department'),
  [QUESTION_TYPES.PICTURE]: i18n.t('weform:image'),
  [QUESTION_TYPES.MATRIX_SINGLE_CHOICE]: i18n.t('weform:matrixSinglechoice'),
  [QUESTION_TYPES.MATRIX_FILL]: i18n.t('weform:matrixFill'),
  [QUESTION_TYPES.SCORE]: i18n.t('weform:score'),
  [QUESTION_TYPES.SIGNATURE]: i18n.t('weform:signature'),
  [QUESTION_TYPES.TRIP_CODE]: i18n.t('weform:tripCode'),
  [QUESTION_TYPES.ORCIDENTIFY]: `${i18n.t('weform:tripCode')}2.0`,
  [QUESTION_TYPES.OCRIDENTIFYHEALTHCODE]: i18n.t('weform:healthCode'),
  [QUESTION_TYPES.OCR_NUCLEICACID_CODE]:i18n.t('weform:nucleicAcidCode')
};


// 选项内容的默认填充
export const setOptionContent = (optionContent, index) => {
  return optionContent ? optionContent : `${i18n.t('weform:options')}${[index]}`;
};

export const MATRIX_CONTENT_TYPE = {
  COLUNM: 'column',
  ROW: 'row',
};

/**
 * 评分题-分数设置
 */
export const RATING_QUESTION = {
  FIVE_POINTS: 5, // 五分制
  TEN_POINTS: 10, // 十分制
};

/**
 * 二维码有效期模块名
 */
 export const BUNDLENAME = {
  WEFORM: 'weform', //  蒲公英
  SERVICECENTER: 'serviceCenter', // 服务中心
  OPENPLATFORM: 'openplatform', // 服务中心
};

/* ocr图片示例 */
export const ocrExamplePicSrc = {
  tripeCode: `${location.origin}/docs/obs/resources/trip_code.svg`,
  acidRecord: `${location.origin}/docs/obs/resources/nucleic_acid_record.svg`,
  healthCode: `${location.origin}/docs/obs/resources/health_code.svg`,
}

const OrcOptionAllKey = {
  /* 红码 */
  RED: 'red',
  /* 绿码 */
  GREEN: 'green',
  /* 黄码 */
  YELLOW: 'yellow',
  /* 橙码 */
  ORANGE: 'orange',
  /* 灰码 */
  GRAY: 'gray',
  /* 阴性 */
  NEGATIVE: 'negative',
  /* 阳性 */
  POSITIVE: 'positive',
  /* 检测中 */
  DETECTED: 'detected',
};
/* 三码结果选项字段的映射 */
export const OrcOptionKeyName = new Map([
  [OrcOptionAllKey.GREEN, i18n.t('weform:greenCode')],
  [OrcOptionAllKey.RED, i18n.t('weform:redCode')],
  [OrcOptionAllKey.YELLOW, i18n.t('weform:yellowCode')],
  [OrcOptionAllKey.ORANGE, i18n.t('weform:orangeCode')],
  [OrcOptionAllKey.GRAY, i18n.t('weform:grayCode')],
  [OrcOptionAllKey.NEGATIVE, i18n.t('weform:negative')],
  [OrcOptionAllKey.POSITIVE, i18n.t('weform:positive')],
  [OrcOptionAllKey.DETECTED, i18n.t('weform:Detected')],
]);

// 填空题不用一键复制内容的类型
export const fillContentNoNeedCopyList = ['phone', 'identityId', 'mailbox', 'telephone'];
// 不需要复制的题目
export const noNeedCopyList = [
  'signature',
  'picture',
  'attachment',
  'location',
  'trip-code',
  'ocrIdentify-tripcode',
  QUESTION_TYPES.OCRIDENTIFYHEALTHCODE,
  QUESTION_TYPES.OCR_NUCLEICACID_CODE,
];

export const SHARE_TYPE = {
  LINK: 'link',
  SHARE: 'share',
  ONLY_WEB: 'onlyWeb',
};

// 应用类型
export const APP_TYPE = {
  // 企业内部应用
  innerApp: '1',
  // 第三方应用
  isv:'2'
}

// 是否为新版管理后台
export const ISNEWROUTE = 'ISNEWROUTE'
